import DiaryService from "@/services/diary.service";

export const diary = {
    namespaced: true,
    state: {
        diaryArray: [],
        monthDiaryArray: [],
        allDiaryArray: [],
        selectedDate: new Date().toLocaleDateString("sv-SE"),
        currentDiary: null,
        loading: false,
    },
    actions: {
        async getDiaryArray({ commit }, params = {}) {
            commit("setLoading", true);
            commit("setDiaryArray", []);

            try {
                const data = await DiaryService.getDiaryList(params);

                const items = Array.isArray(data)
                    ? data
                    : data.diaryArray ?? data.diaries ?? data.data ?? [];

                commit("setDiaryArray", items);

                return items;
            } catch (error) {
                console.error("일기 목록 조회 실패:", error);
                throw error;
            } finally {
                commit("setLoading", false);
            }
        },
        async getMonthDiaryArray({ commit }, { year, month }) {
            try {
                const data = await DiaryService.getDiaryList({
                    year,
                    month
                });

                const items = Array.isArray(data)
                    ? data
                    : data.diaryArray ?? data.diaries ?? data.data ?? [];

                commit("setMonthDiaryArray", items);

                return items;
            } catch (error) {
                console.error("월별 일기 조회 실패:", error);
                throw error;
            }
        },
        async createDiary({ dispatch }, diary) {
            const result = await DiaryService.createDiary(diary);

            await dispatch("getDiaryArray", {
                diaryType: diary.diaryType,
                year: Number(diary.diaryDate.substring(0, 4)),
                month: Number(diary.diaryDate.substring(5, 7))
            });

            return result;
        },
        async getDiaryById({ commit }, id) {
            try {
                const data = await DiaryService.getDiaryById(id);

                const diary = data.diary ?? data.data ?? data;

                commit("setCurrentDiary", diary);

                return diary;
            } catch (error) {
                console.error("일기 상세 조회 실패:", error);
                throw error;
            }
        },
        async deleteDiary({ commit }, id) {
            try {
                await DiaryService.deleteDiary(id);

                commit("removeDiary", id);
                commit("setCurrentDiary", null);

                return true;
            } catch (error) {
                console.error("일기 삭제 실패:", error);
                throw error;
            }
        },
        async updateDiary({ dispatch }, diary) {
            const result = await DiaryService.updateDiary(diary);

            await dispatch("getDiaryArray", {
                diaryType: diary.diaryType,
                year: Number(diary.diaryDate.substring(0, 4)),
                month: Number(diary.diaryDate.substring(5, 7))
            });

            return result;
        },
        setDiaryArray({ commit }, items) {
            commit("setDiaryArray", items);
        },
        setSelectedDate({ commit }, date) {
            commit("setSelectedDate", date);
        },
        setCurrentDiary({ commit }, item) {
            commit("setCurrentDiary", item);
        },
        setLoading({ commit }, loading) {
            commit("setLoading", loading);
        },
        setCleanDiaryArray({ commit }) {
            commit("cleanDiaryArray");
        },
        setDiaryArrayByDate({ state, commit }, date) {
            const items = state.monthDiaryArray.filter(item => {
                const diaryDate = String(item.diaryDate).substring(0, 10);
                return diaryDate === date;
            });

            commit("setSelectedDate", date);
            commit("setDiaryArray", items);
        },
        async getAllDiaryArray({ commit }) {
            try {
                const data = await DiaryService.getDiaryList({});

                const items = Array.isArray(data)
                    ? data
                    : data.diaryArray ?? data.diaries ?? data.data ?? [];

                commit("setAllDiaryArray", items);

                return items;
            } catch (error) {
                console.error("전체 기록 조회 실패:", error);
                throw error;
            }
        },
    },
    mutations: {
        setDiaryArray(state, items) {
            state.diaryArray = items;
        },
        setMonthDiaryArray(state, items) {
            state.monthDiaryArray = items;
        },
        setSelectedDate(state, date) {
            state.selectedDate = date;
        },
        setCurrentDiary(state, item) {
            state.currentDiary = item;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        cleanDiaryArray(state) {
            state.diaryArray = [];
        },
        removeDiary(state, id) {
            state.diaryArray = state.diaryArray.filter(
                item => Number(item.diaryId) !== Number(id)
            );
        },
        setAllDiaryArray(state, items) {
            state.allDiaryArray = items;
        },
    },
};